import { useContext, useState } from 'react';
import { MoreVert } from '@mui/icons-material';
import { Avatar, Box, Chip, Divider, IconButton, Menu, MenuItem, TableCell, TableRow, Tooltip } from '@mui/material';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { CUSTOMERS_ACTIONS } from 'context/customers/customersReducer';
import { CustomerContext } from 'context/customers/customersContext';
import './CustomersTableRow.css';

const { SET_CUSTOMER, SHOW_DEACTIVATE_MODAL, SHOW_FREEZE_MODAL, SHOW_UNFREEZE_MODAL, SHOW_EDIT_SPEND_LIMIT_MODAL } =
    CUSTOMERS_ACTIONS;
dayjs.extend(utc);

export const CUSTOMER_STATUS = {
    APPROVED: 'APPROVED',
    DEACTIVATED: 'DEACTIVATED',
    FROZEN: 'FROZEN'
};

const statusFormat = currentCustomer => {
    const { status } = currentCustomer;
    if (status === CUSTOMER_STATUS.DEACTIVATED) {
        return <Chip label="Deactivated" className="chip chip-danger fw-bold" />;
    }
    if (status === CUSTOMER_STATUS.FROZEN) {
        return <Chip label="Frozen" className="chip chip-info fw-bold" />;
    }
    return <Chip label="Active" className="chip chip-success fw-bold" />;
};

const CustomersTableRow = ({ row: business }) => {
    const { dispatch } = useContext(CustomerContext);
    const [isBusinessMenuOpen, setIsBusinessMenuOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);

    const handleActionsMenuClick = event => {
        setIsBusinessMenuOpen(true);
        setAnchorEl(event.currentTarget);
    };

    const handleCloseActionsMenu = () => {
        setIsBusinessMenuOpen(false);
        setAnchorEl(null);
    };

    const handleFreezeActionClick = async () => {
        setIsBusinessMenuOpen(false);
        setAnchorEl(null);
        dispatch({ type: SET_CUSTOMER, payload: business });
        dispatch({ type: SHOW_FREEZE_MODAL });
    };

    const handleUnfreezeActionClick = async () => {
        setIsBusinessMenuOpen(false);
        setAnchorEl(null);
        dispatch({ type: SET_CUSTOMER, payload: business });
        dispatch({ type: SHOW_UNFREEZE_MODAL });
    };

    const handleDeactivateActionClick = async () => {
        setIsBusinessMenuOpen(false);
        setAnchorEl(null);
        dispatch({ type: SET_CUSTOMER, payload: business });
        dispatch({ type: SHOW_DEACTIVATE_MODAL });
    };

    const handleIncreaseSpendLimitActionClick = async () => {
        setIsBusinessMenuOpen(false);
        setAnchorEl(null);
        dispatch({ type: SET_CUSTOMER, payload: business });
        dispatch({ type: SHOW_EDIT_SPEND_LIMIT_MODAL });
    };

    return (
        <TableRow>
            <TableCell className="table-row-cell">
                <Box className="fw-bold" sx={{ marginBottom: '5px' }}>
                    {business.id_business}
                </Box>
            </TableCell>
            <TableCell className="table-row-cell">{business.legal_name}</TableCell>
            <TableCell>{statusFormat(business)}</TableCell>
            <TableCell>
                <Tooltip title="Customer settings" placement="top">
                    <IconButton data-testid="actions-menu" size="small" sx={{ marginLeft: 2 }} onClick={handleActionsMenuClick}>
                        <Avatar className="action-menu-btn">
                            <MoreVert />
                        </Avatar>
                    </IconButton>
                </Tooltip>
            </TableCell>
            <Menu anchorEl={anchorEl} open={isBusinessMenuOpen} onClose={handleCloseActionsMenu}>
                {business.status === CUSTOMER_STATUS.APPROVED ? (
                    <>
                        <MenuItem onClick={handleFreezeActionClick}>Freeze</MenuItem>
                        <Divider />
                        <MenuItem onClick={handleDeactivateActionClick}>Deactivate</MenuItem>
                        <Divider />
                        <MenuItem onClick={handleIncreaseSpendLimitActionClick}>Change Spend Limit</MenuItem>
                    </>
                ) : (
                    business.status === CUSTOMER_STATUS.FROZEN && (
                        <MenuItem onClick={handleUnfreezeActionClick}>Unfreeze</MenuItem>
                    )
                )}
            </Menu>
        </TableRow>
    );
};

export default CustomersTableRow;
